export default __webpack_public_path__ + "static/drop-in-d964b719340bd5e07b37b0c46848c5e1.png";